import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { EmmaBrandLink } from '../components/EmmaBrandLink'

const AuthSuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams()
  const redirect = searchParams.get('redirect')
  const client = searchParams.get('client')
  const machineId = searchParams.get('machineId')
  
  // Build subscribe URL if coming from upgrade flow
  const subscribeUrl = redirect === '/subscribe' && client === 'premiere' && machineId
    ? `/subscribe?client=premiere&machineId=${encodeURIComponent(machineId)}`
    : null

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', padding: '2rem 0' }}>
      <div className="container">
        <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
          <div style={{
            background: 'white',
            padding: '3rem',
            borderRadius: '1rem',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
          }}>
            <EmmaBrandLink />
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
            <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem' }}>
              Authentication Successful!
            </h1>
            <p style={{ fontSize: '1.125rem', color: '#6b7280', marginBottom: '2rem' }}>
              You have successfully authenticated with your Google account.
            </p>
            <p style={{ fontSize: '1rem', color: '#6b7280', marginBottom: '2rem' }}>
              Your Premiere Pro plugin will automatically receive your authentication tokens.
              You can close this window and return to the plugin.
            </p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              {subscribeUrl && (
                <a href={subscribeUrl} style={{
                  display: 'inline-block',
                  padding: '0.75rem 2rem',
                  backgroundColor: '#10b981',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '0.5rem',
                  fontWeight: 'bold'
                }}>
                  Continue to Subscribe
                </a>
              )}
              <a href="/account" style={{
                display: 'inline-block',
                padding: '0.75rem 2rem',
                backgroundColor: '#3b82f6',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '0.5rem',
                fontWeight: 'bold'
              }}>
                Go to Account
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthSuccessPage

